import { useMemo } from 'react'
import { useCutReducedData } from './useCutReducedData'

export function useCutSource(source: Float32Array) {
  const cutReducedData = useCutReducedData()
  return useMemo(() => cutReducedData(source), [source, cutReducedData])
}
